import ContractNewPage from "./ContractNewPage";

export default ContractNewPage;
